<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-课程-修改
    -->
    <el-dialog
    title="修改课程"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
      :append-to-body="true"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
    
      
      <el-form-item label="封面：" prop="model.cover">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.cover" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                  </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
      
      <el-form-item label="课程名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入课程名称" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="课程类型" prop="name">
        <el-radio-group v-model="form.type" @change="changeClick">
                <el-radio :label="1">视频</el-radio>
                <el-radio :label="2">文档</el-radio>
              </el-radio-group>
      </el-form-item>

          
      
    <el-form-item label="文档说明" v-if="form.type == 2" prop="model.image">
      <div class="draggable-list">
        <div v-for="(item, index) in form.url" :key="index">
              <div class="item">
                {{ item.real_name?item.real_name:item.name }}
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'files')">
                  <i class="el-icon-close"></i></a>
              </div>
            </div>
        <div class="item img-select" @click="openFileUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>



    <el-form-item label="视频" v-if="form.type == 1" prop="model.os_design_sketch">
      <div class="draggable-list">
        <draggable class="wrapper">
          <transition-group>
            <div  v-for="(itemA, indexA) in form.url" :key="itemA.file_path">
              <div class="item" style="width: 300px;height: 200px;">
                <video controls :src="itemA.file_path" width="300" height="200" alt="file_path" ></video>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(indexA,'video')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openVideoUpload(index,'video')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>      

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
   
    <Upload v-if="isProductUpload" :config="{ total: 50 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

    <Upload v-if="isVideoUpload" :config="{ total: 40 }" :isupload="isVideoUpload" @returnImgs="returnvideoFunc">上传视频
    </Upload>

    <Upload v-if="isFileUpload" :config="{ total: 50 }" :isupload="isFileUpload" @returnImgs="returnFileFunc">上传文件
    </Upload>  
   </div>
</el-dialog>
  
</template>

<script>
import OcourseApi from '@/api/ocourse.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        sort:50,
        type:1,
        url:[],
        cover:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      ocourse_category:[],
      isProductUpload:false,
      isVideoUpload:false,
      isFileUpload:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();

  },
  props: ["open_add","ocourse_id",'ocourse_catalogue_id','ocourse_url_id'],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      OcourseApi.detailUrl({ocourse_url_id: self.ocourse_url_id},true).then(res => {
          self.form = res.data;

          self.isImg = true
          self.loading = false;
     
        })
        .catch(error => {});
    },
    changeClick(){
      this.form.url = [];
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.ocourse_url_id = self.ocourse_url_id
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          OcourseApi.editUrl(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },
    openVideoUpload:function (code) {
      this.isVideoUpload = true;
      this.code = code
    },
    openFileUpload:function (code) {
      this.isFileUpload = true;
      this.code = code
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["jpg", "png",'jpeg'];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let cover = this.form.cover;
      
        var obj = e
        cover = obj
        this.form.cover = cover;
        this.$set(this.form, "cover", cover);
      }
      this.isProductUpload = false;
    },

    returnvideoFunc(e){
      if (e != null) {
        let imgExpt = ["mp4", "mp3"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("视频类型有误,请选择正确的视频格式");
          return false;
        }
        let url = this.form.url;
      
        var obj = e
        url = obj
        this.form.url = url;
        this.$set(this.form, "url", url);
      }
      this.isVideoUpload = false
    },
    returnFileFunc(e){
      if (e != null) {
        let imgExpt = ['pdf', 'docx', 'doc', 'xlsx', 'xls','pptx'];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("文件类型有误,请选择正确的文件格式");
          return false;
        }
        let url = this.form.url;
      
      var obj = e
      url = obj
      this.form.url = url;
      this.$set(this.form, "url", url);
      }
      this.isFileUpload = false
    },
     /*删除商品图片*/
     deleteImg(index,code) {
      if(code == 'files'){
        this.form.url.splice(index, 1);
      }else if(code == 'video'){
        this.form.url.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ocourse/index/catalogue/url/part/edit.vue